import { useEffect } from 'react'
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom'

import { Episode } from '@lyrahealth-inc/shared-app-logic/src/models/episodes/Episodes'

export const useSyncClientRelId = (clientId: string | null | undefined, episodes: Episode[] | undefined) => {
  const location = useLocation()
  const navigate = useNavigate()
  const [searchParams, setSearchParams] = useSearchParams()

  useEffect(() => {
    if (!clientId) {
      return
    }

    const clientEpisodes = episodes?.filter((episode) => episode.patient_id === clientId) ?? []
    const currentRelId = searchParams.get('relId')
    if (
      !clientEpisodes.length ||
      (currentRelId && clientEpisodes.some((episode) => episode.provider_patient_id === currentRelId))
    ) {
      return
    }

    if (`${window.location.pathname}${window.location.search}` !== `${location.pathname}${location.search}`) {
      return
    }

    const relId = clientEpisodes[0].provider_patient_id
    if (!relId) {
      return
    }

    // Use navigate instead of setSearchParams to preserve the state
    if (location.state) {
      const newSearchParams = new URLSearchParams(location.search)
      newSearchParams.set('relId', relId)

      navigate(location.pathname + `?${newSearchParams.toString()}`, {
        replace: true,
        state: location.state,
      })
    } else {
      setSearchParams(
        (prev) => {
          prev.set('relId', relId)
          return prev
        },
        { replace: !!currentRelId },
      )
    }
  }, [clientId, episodes, location, navigate, searchParams, setSearchParams])
}
